import { isCrudRouteEnabledForTenant } from '@pelicargo/tenants';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Error } from './components/Error';
import { Pelicalc } from './components/Pelicalc';
import { AuthenticatedGuard } from './guards/AuthenticatedGuard';
import { UnauthenticatedGuard } from './guards/UnauthenticatedGuard';
import { AccountsScreen } from './screens/Accounts';
import { AiInboxScreen } from './screens/AiInbox';
import { AirlineQuotesScreen } from './screens/AirlineQuotes';
import { AirportsScreen } from './screens/Airports';
import { BacklogsScreen } from './screens/Backlogs';
import { BookingScreen } from './screens/Booking';
import { ConfigurationScreen } from './screens/Configuration';
import { ContactsScreen } from './screens/Contacts';
import { CredentialScreen } from './screens/Credentials';
import { GeneralConfiguration } from './screens/GeneralConfiguration';
import { ImportScreen } from './screens/Import';
import { InlandQuotesScreen } from './screens/InlandQuotes';
import { InstructionsScreen } from './screens/Instructions';
import { Login } from './screens/Login';
import { MarkupConfigurationsScreen } from './screens/MarkupConfigurations';
import { ProvidersScreen } from './screens/Providers';
import { RatesScreen } from './screens/Rates';
import { RequestEmailsScreen } from './screens/RequestEmails';
import { RequestsScreen } from './screens/Requests';
import { RouteEditor } from './screens/RouteEditor';
import { RulesScreen } from './screens/Rules';
import { SingleRequestScreen } from './screens/SingleRequest';
import { SnippetsScreen } from './screens/Snippets';
import { SurchargesScreen } from './screens/Surcharges';
import { ThemeConfiguration } from './screens/ThemeConfiguration';
import { UsersScreen } from './screens/Users';

const NoRequestSelected = () => (
  <Error title="No Request Selected" description="Please select a request from the sidebar to continue." />
);

export const Router = () => (
  <Routes>
    <Route path="/login" element={<UnauthenticatedGuard loggedInPath="/requests" />}>
      <Route index element={<Login />} />
    </Route>

    <Route path="/" element={<AuthenticatedGuard />}>
      <Route path="/" element={<RequestsScreen />}>
        <Route index element={<NoRequestSelected />} />
        <Route path="requests">
          <Route path=":requestId" element={<Navigate to="airline" replace />} />
          <Route path=":requestId/airline" element={<SingleRequestScreen />}>
            <Route index element={<AirlineQuotesScreen />} />
          </Route>
          <Route path=":requestId/inland" element={<SingleRequestScreen />}>
            <Route index element={<InlandQuotesScreen />} />
          </Route>
          <Route path=":requestId/booking" element={<SingleRequestScreen />}>
            <Route index element={<BookingScreen />} />
          </Route>
          <Route path=":requestId/emails" element={<SingleRequestScreen />}>
            <Route index element={<RequestEmailsScreen />} />
          </Route>
        </Route>
      </Route>
      {/* The sidebar hides the link for a tenant without the `ai-inbox` crud flag; this keeps
          the URL from being an unguarded way in. The api enforces the same flag. */}
      <Route
        path="/ai-inbox"
        element={isCrudRouteEnabledForTenant('/ai-inbox') ? <AiInboxScreen /> : <Navigate to="/" replace />}
      />
      <Route path="/accounts" element={<AccountsScreen />} />
      <Route path="/providers" element={<ProvidersScreen />} />
      <Route path="/airports" element={<AirportsScreen />} />
      <Route path="/contacts" element={<ContactsScreen />} />
      <Route path="/users" element={<UsersScreen />} />
      <Route path="/instructions" element={<InstructionsScreen />} />
      <Route path="/surcharges" element={<SurchargesScreen />} />
      <Route path="/markup-configurations" element={<MarkupConfigurationsScreen />} />
      <Route path="/rates" element={<RatesScreen />} />
      <Route path="/rates/new" element={<ImportScreen />} />
      <Route path="/rates/new/import" element={<ImportScreen />} />
      <Route path="/rules-data" element={<RulesScreen />} />
      <Route path="/route-editor" element={<RouteEditor />} />
      <Route path="/configuration" element={<ConfigurationScreen />} />
      <Route path="/configuration/general" element={<GeneralConfiguration />} />
      <Route path="/configuration/theme" element={<ThemeConfiguration />} />
      <Route path="/configuration/snippets" element={<SnippetsScreen />} />
      <Route path="/configuration/credentials" element={<CredentialScreen />} />
      <Route path="/backlogs" element={<BacklogsScreen />} />
      <Route path="/calculator/" element={<Pelicalc />} />
      <Route path="/calculator/:initialQuery" element={<Pelicalc />} />
    </Route>

    <Route path="*" element={<Error title="Error" description="Error has occurred" />} />
  </Routes>
);
